import { FC } from "react";
import { PrimaryButton, SecondaryButton } from "shared/components/ui/button";
import styled from "styled-components";
import { useMeshing } from "./hook/use-meshing";
import LoadingDots from "shared/components/ui/loading-dots";
import { MeshProjectStatusMPValueEnum } from "lib/apis/mesh-projects/api";
import { formatTime } from "shared/utils/dates";

interface Props {
  onClose: () => void;
}

const Meshing: FC<Props> = ({ onClose }) => {

  const { status, error, seconds, lastEvents, cancelMeshing } = useMeshing();

  return (
    <Wrapper className="text-xs">
      <Header>
        <h1>Meshing</h1>
      </Header>
      <Content>
        <Box>
          <div className="flex">
            <h1>{status} </h1>
            <div className="flex-grow flex justify-center">
              {status === MeshProjectStatusMPValueEnum.Running && <LoadingDots />}
              {status === MeshProjectStatusMPValueEnum.Error && <h1>{error}</h1>}
            </div>
            <h1>{formatTime(seconds)}</h1>
          </div>
          <h1>Events:</h1>
          <div>{lastEvents.map((e, i) => (
            <li key={e.name + i}>
              {e.name} - {e.date.toLocaleString()}
            </li>
          ))}</div>
        </Box>
        <Box className="flex justify-center gap-2">
          <PrimaryButton disabled={status === MeshProjectStatusMPValueEnum.Running} onClick={() => {
            onClose();
          }}>
            Accept
          </PrimaryButton>
          <SecondaryButton
            disabled={status === MeshProjectStatusMPValueEnum.Canceled || status === MeshProjectStatusMPValueEnum.Error}
            onClick={() => { cancelMeshing() }}>
            Cancel
          </SecondaryButton>
        </Box>
      </Content>
    </Wrapper>
  );
};

const Wrapper = styled.div`
        overflow: hidden;
        border-radius: 4px;
        width: 300px;
        margin: -32px;
        background-color: var(--color-gray-300);
        `;
const Header = styled.div`
        background-color: var(--color-gray-300);
        border-bottom: 2px solid var(--color-primary);
        padding: 6px;
        display: flex;
        justify-content: space-between;
        `;
const Content = styled.div`
        display: grid;
        gap: 4px;
        padding: 6px;
        `;
const Box = styled.div`
        background-color: var(--color-gray-200);
        padding: 8px;
        border-radius: 4px;
        overflow: hidden;
        `;
export default Meshing;